import React from "react";
import { useDataProvider } from "react-admin";

import { CustomFieldColumn } from "./CustomFieldColumn";

export const CustomFieldDatagridWrapper = ({
	children,
	filterValues,
	data,
	permissions,
	customFields,
	...rest
}) => {
	const customFieldColumns = React.useMemo(() => {
		if (customFields.length === 0) return [];

		return customFields.map((field) => (
			<CustomFieldColumn
				source={`custom_fields_${field.key}`}
				label={field.name}
				key={`custom_${field.key}`}
				customField={field}
				sortable={true}
				customFieldKey={field.key}
				type={field.type}
			/>
		));
	}, [customFields]);

	return (
		<>
			{React.cloneElement(children, {
				customFieldColumns,
				filterValues,
				data,
				permissions,
				...rest,
			})}
		</>
	);
};
